import PagePlaceholder from '@/components/PagePlaceholder';

export default function SolutionsInPracticePage() {
  return (
    <PagePlaceholder
      title="Solutions in Practice"
      subtitle="Illustrative scenarios showing how MorphenIQ shapes intelligence around real business challenges."
    />
  );
}